export interface IColumns {
  id: 'pair' | 'total' | 'revenue'
  label: string
  // eslint-disable-next-line
  format?: (value: any) => number
}

export interface IDataItem {
  pair: string
  total: number
  revenue: number
}

export interface IDataList {
  pairs: IDataItem[]
  total: number
  revenue: number
}
export interface IData {
  request: string
  columns: IColumns[]
}

export const revenueData: IData = {
  request: 'trading/revenue-by-asset',
  columns: [
    {
      id: 'pair',
      label: 'PAIRS',
    },
    {
      id: 'total',
      label: 'TOTAL VOLUME',
      // eslint-disable-next-line
      format: (value: any) => value?.toFixed(3),
    },
    {
      id: 'revenue',
      label: 'REVENUE',
      // eslint-disable-next-line
      format: (value: any) => value?.toFixed(3),
    },
  ],
}
